export default __webpack_public_path__ + "static/media/logo-bayadFA.546d72ba.svg";